import ChapterDisplay from './ChapterDisplay';
import Comments from './Comments';

export default function Capitulo4() {
    const section = 'el-inframundo';
    const title = 'El inframundo';
    const description = '¡No sabes el susto que me llevé!';
    const text = '<p>Me caí en un hoyo y no dejaba de caer. Aterricé en una cueva enorme, oscura y con un montón de raspones. ¡Qué miedo! Estaba súper asustada, pero de repente, ¡Taquito llegó! Me asustó al ladrarme, pero qué bueno que está conmigo.</p><p>Para nuestros antepasados, <b>las cuevas</b> no eran solo hoyos en la tierra, ¡eran lugares súper sagrados y mágicos! Se creía que eran las entradas al inframundo, el lugar donde vivían los dioses y los espíritus de la montaña. También se pensaba que de las cuevas más oscuras y profundas había salido el maíz, el frijol y hasta la humanidad misma, como si fueran el vientre de la madre tierra. Para mí, esto nos enseña que los pueblos prehispánicos veían a la naturaleza con mucho respeto y admiración, buscando en ella las respuestas a las grandes preguntas de la vida. Las cuevas nos recuerdan que a veces la magia y los secretos más grandes no están afuera, sino en lo profundo de nuestra propia tierra y nuestra historia.</p><p>Luego, ¡pasó algo súper loco! Hice que un esqueleto se volviera polvo, y su amiga, Tinskani, se enojó un montón. Pero Taquito se calmó y se hicieron amigos. Tinskani me dijo que este lugar es el Comiehchúcuaro, el mundo de los muertos purépechas, pero que yo no estoy muerta. ¡Qué alivio!</p><p>Taquito me tocó la cabeza y, ¡pum!, de repente pude ver que todo no es oscuro, ¡es súper colorido! Y la ropa que me dio Tinskani, este rebozo, se siente... mágico. Todo es demasiado, neta. Y lo más extraño de todo es que ¡ya no tengo hambre!</p>';
    const image = 'https://www.diadelavida.com/images/chapters/deco_capitulo4.png';
    const image_number = 'https://www.diadelavida.com/images/numbers/4.png'
    const image_size = 'contain';
    const image_position = 'center';
    const image_height = 400;
    const comments_prompt = '¿Qué opinas de Tinskani? ¿Te gustaría visitar el Comiehchúcuaro? ¡Deja tu comentario!';

    const images = [
        {
            id: 1,
            src: 'https://www.diadelavida.com/images/chapters/capitulo4_main.jpg',
            alt: 'Noche de Muertos | Día de la Vida - Capítulo 4',
            description: '¡¿Dónde estoy?!'
        },
        {
            id: 2,
            src: 'https://diadelavida.com/images/cards/card_tsiri_01.jpg',
            alt: 'Noche de Muertos | Día de la Vida - Capítulo 4',
            description: '¿Cuánto tiempo llevarán aquí atrapados?'
        },
        {
            id: 3,
            src: 'https://diadelavida.com/images/cards/card_tinskani_01.jpg',
            alt: 'Noche de Muertos | Día de la Vida - Capítulo 4',
            description: 'No se qué tan bien nos podremos llevar...'
        }
    ];

    return (
        <div>
            <ChapterDisplay
                section={section}
                title={title}
                description={description}
                text={text}
                image={image}
                imageSize={image_size}
                imagePosition={image_position}
                imageHeight={image_height}
                images={images}
                imageNumber={image_number}
            />
            <div id='users-comments'>
                <div className="comments-deco"></div>
                <div className="container">
                    <div className="row">
                        <Comments sectionId={section} commentsPrompt={comments_prompt} />
                    </div>
                </div>
            </div>
        </div>
    );
}